import React, { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import { kbdEvent} from "../utils/Utils";
import Spin from "../ui/Spin";
import { getSignal } from "../App";
import List from "../ui/List";
import InventoryOrder, { drawOrderHeaders } from "./InventoryOrder";
import { createModal } from "../hooks/createModal";


export default function InventoryOrders2(props) {
    const {
        controller = "",
        route = "",
        fullData = {},
        fetchExtra = () => { },
        setFullData = () => { },
        switchView = () => { },
        togglePubstock = () => { },
        sell_price = 0,
        pending_orders = { rows: [], total: 0 },
        updateSellPrice = () => {},
    } = props;


    const signal = getSignal();
    const session = signal?.session;
    const splitter = session?.is_splitter_active;
    const is_active = window.bm_state.value === route;

    const [selected, setSelected] = useState("");
    const [loading, setLoading] = useState(false);


    const orders = pending_orders;



    const openFull = (_order) => {
        let _prev = {...selected};
        setSelected("")
        window.bm_state.value = ROUTES.INVENTORY.ORDER
        createModal({
            component: <InventoryOrder
               
                route={ROUTES.INVENTORY.ORDER}
                onSellPriceChange={(_sell_price) => updateSellPrice(_sell_price)}
                onSelect={() => setSelected(_order)}
                onSave={() => { fetchExtra(); switchView("inventory"); }}
                onExit={() =>{
                     window.bm_state.value = ROUTES.INVENTORY.ORDERS
                     setSelected(_prev);
                }}
                onRemove={() => { fetchExtra(); switchView("inventory"); }}
                fullData={fullData}
                controller={controller}
                order={_order}
                full={true}
                sell_price={sell_price}
                edit={true}
            />, closable: true, title: "Order",
            callback: (e) => {
               
            }
        });

    }

    const listOrders = () => {
        return orders.rows.map((item, index) => {
            return (
               
                <InventoryOrder
                    is_active={is_active}
                    selected={selected}
                    setSelected={setSelected}
                    onSellPriceChange={(_sell_price) => updateSellPrice(_sell_price)}
                    updateSellPrice={updateSellPrice}
                    onSelect={() => setSelected(item)}
                    onSave={() => { fetchExtra(); switchView("inventory"); }}
                    onExit={() => switchView("inventory")}
                    onRemove={() => { fetchExtra(); switchView("inventory"); }}
                    onOpenFull={(e) => {openFull(e)}}
                    route={route} 
                    fullData={fullData}
                    controller={controller}
                    order={item}
                    full={false}
                    sell_price={sell_price}
                    edit={(selected?.order_id === item?.order_id)}
                />
                
            )
        })
    }

    useEffect(() => {
        if (is_active) {
            if(!selected){
                setSelected(pending_orders?.rows?.[0] || "");
            }
        } else {
            setSelected("");
        }
    }, [is_active, selected])

    const move = (inc = 1) => {

        const i = orders.rows.findIndex(o => o?.order_id === selected?.order_id);
        let _next = orders.rows[Math.min(
            orders.rows.length - 1,
            Math.max(0, i + inc)
        )];

        setSelected(_next);
    };

  

    useEffect(() => {

        if (loading || props.loading) { return; }
        const actions = [
            { key: KBD.COMMA, action: () => togglePubstock() },
            { key: KBD.ARROW_UP, action: () => move(-1) },
            { key: KBD.ARROW_DOWN, action: () => move(1) },
        ];
        const cleanup = listen(
            controller, route, actions, () => { }, [KBD.TAB, KBD.SHIFT_TAB, KBD.ARROW_LEFT, KBD.ARROW_RIGHT, KBD.ARROW_UP, KBD.ARROW_DOWN, KBD.ENTER, KBD.SHIFT_ENTER, KBD.ESCAPE, KBD.PAGE_DOWN, KBD.COMMA], [], []
        );
        return cleanup;
    }, [route, loading, props.loading, orders, selected]);


    return (

        <Spin style={{ height: "100%", display: "flex", flexDirection: "column", flex: "1 1 0%", }} loading={loading || props.loading}>

            <div className={"cust-shift-down"} style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: "0" }}>

                <table onDoubleClick={() => { if (!is_active) { kbdEvent(KBD.O); return; } }} style={{ width: "100%", backgroundColor: "var(--card-bg)", "marginBottom": "-1px" }} className={"ui-table stretch-last"}>
                    {drawOrderHeaders()}
                </table>

                <div style={{ "flex": "1", "backgroundColor": "var(--card-bg)" }}>
                    <div style={{"height" : "100%"}}>

                    {(!props?.loading && !loading && <List row_height={(splitter) ? 89 : 34} items={listOrders()} />)}
                    </div>
                </div>

                <div key={selected?.stock?.isbn} className="fade" style={{ flex: "0 0 auto", flexShrink: 1, alignItems: "flex-end", display: "flex", backgroundColor: "var(--input-bg)", border: "1px solid var(--border-secondary)" }}>{props.pubstock}</div>
            </div>
        </Spin>

    )

}